import React from 'react'
import cn from 'classnames'

import { useTab } from '@components/Tabs/Tabs'
import { TabModeEnum } from '../interface'

interface TabProps {
  tabId: string
  children: React.ReactNode
  dataTest?: string
  disabled?: boolean
}

export function Tab({ tabId, dataTest, disabled = false, children }: TabProps) {
  const { mode, activeTab, handleUpdateActiveTab } = useTab()

  return (
    <div className='relative'>
      <button
        data-test={dataTest}
        type='button'
        disabled={disabled}
        className={cn(
          'flex px-[20px] py-[9px] min-w-fit h-[40px] items-center justify-center cursor-pointer font-light whitespace-nowrap dark:text-dark-10',
          {
            'rounded-[8px] bg-secondary dark:bg-purple text-white dark:text-white-2 dark:border-purple':
              tabId === activeTab && mode === TabModeEnum.BOX,
            'rounded-[8px] bg-gray-4 dark:bg-dark-13 text-secondary-1 dark:text-dark-10 dark:border-dark-13':
              tabId !== activeTab && mode === TabModeEnum.BOX,
            'text-secondary font-bold':
              tabId === activeTab && mode === TabModeEnum.LINE,
            'text-secondary-1':
              tabId !== activeTab && mode === TabModeEnum.LINE,
            'cursor-no-drop opacity-40': disabled,
          }
        )}
        onClick={() => handleUpdateActiveTab(tabId)}
      >
        {children}
      </button>
      {mode === TabModeEnum.LINE && (
        <hr
          className={cn(
            'absolute bottom-0 lefy-0 w-full h-[3px] bg-secondary dark:bg-dark-10 z-[2] rounded-[3px]',
            { hidden: tabId !== activeTab }
          )}
        />
      )}
    </div>
  )
}
